import React, { useState, useEffect } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./UploadProgressPopup.scss";
import images from "../../../assets/images";
import { BulkFileState } from "../CommonBulkUpload/CommonBulkUpload";
import { AdminBulkFileState } from "../../../pages/AdminBulkUpload/components/BulkUpload";

interface UploadToasterType {
  uploaded: boolean;
  setuploaded: (val: boolean) => void;
  uploadProgress: number;
  fileName: string|undefined;
  setUploadFileName: any;
  uploadFailed:boolean;
  setUploadFailed:any;
  setUploadProgress:any;
  FilesStatusData?: Array<BulkFileState> | Array<AdminBulkFileState>;
  setFilesStatusData?: (val: Array<BulkFileState>) => void;
  totalProgress?: number;
  setTotalProgress?: (val: number) => void;
  failureCount?: number;
  successCount?: number;
}

const UploadToaster: React.FC<UploadToasterType> = ({successCount, failureCount, uploaded, FilesStatusData, setFilesStatusData, totalProgress, setTotalProgress, setuploaded, uploadProgress, setUploadProgress, fileName, setUploadFileName, uploadFailed, setUploadFailed}) => {
  const [expanded, setExpanded] = useState(true);
  const { Check, UploadIcon, UploadFailedSvg } = images;

  // expand upload progress bar
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleDoneButtonClick = () => {
      setuploaded(false);
      setUploadFileName('');
      setUploadFailed(false); 
      setUploadProgress(0);
      if(setTotalProgress) {
        setTotalProgress(0);
      }
  }

   // Automatically close the popup after a certain time when upload is complete
   useEffect(() => {
    if (uploadProgress === 100 || (totalProgress && (totalProgress === 100) ) || uploadFailed === true || ((typeof successCount === "number") && (typeof failureCount === "number") && ((successCount + failureCount) === FilesStatusData?.length) &&  FilesStatusData && FilesStatusData.length === 1)) {
      const timer = setTimeout(() => {
        setuploaded(false);
        setUploadFailed(false);
        setUploadFileName('');
        setUploadProgress(0);
        if(setTotalProgress) {
          setTotalProgress(0);
        }
      }, 5000);

      return () => clearTimeout(timer); // Clear the timer if the component is unmounted
    }
  }, [uploadProgress,setuploaded,uploadFailed, totalProgress, successCount, failureCount]);
  
  return (
    <>
     {/* Backdrop */}
    <div className="upload-backdrop" />
      {uploaded && 
      !(FilesStatusData && FilesStatusData?.length > 1) ?
      <div className="UploadedContainer">
        <div className="header" onClick={handleExpandClick}>
          <span className={(uploadFailed === true || (failureCount === 1)) ? 'failed' :uploadProgress === 100 ? 'success': ''}>{(uploadFailed === true || ( (FilesStatusData && FilesStatusData?.length > 1) && (failureCount) === (FilesStatusData?.length))) ? 'Upload Failed' : uploadProgress === 100 ? 'Uploaded Successfully' : 'Uploading'}</span>
          <div className={ expanded ? "rotate_down" : "rotate_up" }>
            <ExpandMoreIcon />
          </div>
        </div>

        {expanded && (
          <div className="card">
            <div className="card-content">
              {(uploadFailed === true || (failureCount === 1)) ? (
                <div className="CheckIcon">
                <img src={UploadFailedSvg} alt="failIcon"/>
              </div>
              ) : uploadProgress === 100 ? (
                <div className="CheckIcon">
                  <img src={Check} alt="tick Icon"/>
                </div>
              ) : (
                <div className="spinnerContainer">
                  <div className="spinner" />
                  <img src={UploadIcon} alt="uploadIcon" className="UploadIcon" />
                </div>
              )}
              <div className="file-details">
                <div>{(fileName && fileName.trim() !== '') ? fileName : (FilesStatusData?.[0]?.uploadFileName && FilesStatusData?.[0]?.uploadFileName.trim() !== '') ? FilesStatusData?.[0]?.uploadFileName : ''}</div>
                {(uploadFailed === true || (failureCount === 1)) ? (
                  <div style={{ fontSize: "12px", color: "#757575" }}>
                    Failed
                  </div>
                ):(
                  <div style={{ fontSize: "12px", color: "#757575" }}>
                    {uploadProgress}%
                  </div>
                )}
                <div className="progress-bar-container">
                  <div
                    className="progress-bar"
                    style={{ width: `${uploadProgress}%` }}
                  ></div>
                </div>
              </div>
            </div>
            <button className="doneBtn" disabled={!(uploadProgress === 100 || uploadFailed === true || (failureCount === 1))} onClick={() => {setuploaded(false);setUploadFileName('');setUploadFailed(false); setUploadProgress(0);}}>
              <label className="button">Done</label>
            </button>
          </div>
        )}
      </div>
      : 
      <div className="UploadedContainer multiple">
        <div className="header" onClick={handleExpandClick}>
          {(uploadFailed === false || !(FilesStatusData?.length === (failureCount))) && <span style={{ fontSize: "12px", color: "#757575" }}>{totalProgress}% </span>}<span className={(uploadFailed === true || (FilesStatusData?.length === (failureCount))) ? 'failed' : (totalProgress === 100) ? 'success': ''}>{(uploadFailed === true || (FilesStatusData?.length === failureCount)) ? 'Upload Failed' : (totalProgress  === 100 || ((typeof successCount === "number") && (typeof failureCount === "number") && (successCount > 0) && ((successCount + failureCount) === FilesStatusData?.length) &&  FilesStatusData && FilesStatusData.length > 0)) ? 'Uploaded Successfully' : 'Uploading'}</span>
          <div className={ expanded ? "rotate_down" : "rotate_up" }>
            <ExpandMoreIcon />
          </div>
        </div>

        {expanded && (
          <div className="card">
             <div
              className="multi-file-list"
              style={{
                maxHeight: "150px",
                overflowY: "auto",
                marginBottom: "10px",
                paddingRight: "5px"
              }}
            >
              {FilesStatusData?.map((f, idx) => {
                const isDone = f?.success === true;
                const isFailed = f?.success === false;
                const uploadFileName = f?.uploadFileName;
                const perFileProgress = f?.progress;

                return (
                  <div className="card-content" key={idx} style={{paddingBottom: '15px'}}>
                    {isFailed  === true ? (
                      <div className="CheckIcon">
                      <img src={UploadFailedSvg} alt="failIcon"/>
                    </div>
                    ) : isDone ? (
                      <div className="CheckIcon">
                        <img src={Check} alt="tick Icon"/>
                      </div>
                    ) : (
                      <div className="spinnerContainer">
                        <div className="spinner" />
                        <img src={UploadIcon} alt="uploadIcon" className="UploadIcon" />
                      </div>
                    )}
                    <div className="file-details">
                      <div>{uploadFileName ? uploadFileName : ''}</div>
                        <div style={{ fontSize: "12px", color: "#757575" }}>
                          {isFailed ? 'Failed' : `${perFileProgress}%`}
                        </div>
                    </div>
                  </div>
                )}
              )}
            </div>
            <button className="doneBtn" disabled={!(totalProgress === 100 || uploadFailed === true || ((typeof successCount === "number") && (typeof failureCount === "number") && ((successCount + failureCount) === FilesStatusData?.length) &&  FilesStatusData && FilesStatusData.length > 0))} onClick={handleDoneButtonClick}>
              <label className="button">Done</label>
            </button>
          </div>
        )}
      </div>
      }
    </>
  );
};

export default UploadToaster;
